export default "__VITE_ASSET__CcS7ecD7__"